var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuarterlyReport16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9H4.5V10H7.5V9Z",
    fill: "#2767A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7H4.5V8H8.5V7Z",
    fill: "#2767A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.4961H12.5V5C12.5 4.94995 12.5 4.8501 12.45 4.80005C12.4 4.75 12.4 4.69995 12.3499 4.6499L8.84995 1.1499C8.8 1.1001 8.74995 1.05005 8.69995 1.05005C8.65 1 8.55005 1 8.5 1H3.5C3.25 1 3 1.1001 2.80005 1.30005C2.6 1.5 2.5 1.75 2.5 2V14C2.5 14.25 2.6 14.5 2.80005 14.7C3 14.8999 3.25 15 3.5 15H7.47365V14H3.5V2H7.5V5C7.5 5.25 7.6 5.5 7.80005 5.69995C8 5.8999 8.25 6 8.5 6H11.5V8.4961ZM8.5 5V2.19995L11.3 5H8.5Z",
    fill: "#2767A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13L12.7676 11H13.5V10H12.2324L10.4648 12H9.5V10H8.5V14C8.5 14.2652 8.60536 14.5196 8.79289 14.7071C8.98043 14.8946 9.23478 15 9.5 15H13.5V14H9.5V13H11Z",
    fill: "#2767A9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterlyReport16);
export default __webpack_public_path__ + "static/media/QuarterlyReport16.6469de33a47dac29a58f1c5abc1a9567.svg";
export { ForwardRef as ReactComponent };